// extracted by mini-css-extract-plugin
export var vacation = "Promo-module--vacation--132b1";
export var vacationButton = "Promo-module--vacationButton--be77b";
export var vacationHeading = "Promo-module--vacationHeading--ca204";
export var vacationWrapper = "Promo-module--vacationWrapper--79b4d";